<template>
	<div>
		<div v-if="data.adminPanel && !data.hideBack" class="pb-3 text-left">
			<v-btn class="" dark small left title="بازگشت" @click="$emit('back')">
				بازگشت
				<v-icon dark>
					mdi-chevron-left
				</v-icon>
			</v-btn>
		</div>

		<installments :userloan="data.userloan" :area="data.adminPanel ? 'admin' : area"
			@changed="(id) => $emit('changed', id)" />

		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>

	export default {
		name: 'LoanInstallmentsView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'installments': () => import('@/components/forms/Installments.vue'),
		},
		props: {
			data: { type: Object },
			area: { type: String, default: '' },
		},
		data() {
			return {
				loading: false,
				errorMessages: '',
			}
		},
		computed: {

		},
		mounted() {

		},
		methods: {

		},
	}
</script>
<style></style>
